document.addEventListener('DOMContentLoaded', () => {
  // Legacy '?collection=' deep links. In category tab mode the inline
  // controller in the build-your-box section already maps this parameter
  // to a category, so skip the old scroll behaviour.
  if (window.__categoryTabsActive) return;
  setTimeout(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const collectionParam = urlParams.get('collection');

  if (collectionParam) {
    // If collection parameter exists, find and scroll to the corresponding category
    const categoryLink = document.querySelector(`.category-filter-link[data-handle="${collectionParam}"]`);
    if (categoryLink) {
      scrollToCollection(categoryLink);
    }
  }
  }, 1500);
})

let _isScrolledIntoView = (el) => {
  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;
  // Only completely visible elements return true:
  var isVisible = (elemTop >= 0);
  // Partially visible elements return true:
  // isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible;
}

let _isMobile = () => {
  if (window.matchMedia('(any-hover: none)').matches || document.documentElement.clientWidth < 768) {
    return true;
  }
  return false;
};


// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
const MONEY_FORMAT = "${{amount}}";
const formatMoney = (cents, format) => {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || MONEY_FORMAT);
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  value = formatWithDelimiters(cents, 2);
  return formatString.replace(placeholderRegex, value);
};


const scrollToCollection = (categoryLink) => {
  let handle = categoryLink.dataset.handle;
  let target = document.querySelector(`.build-box-collection[data-collection="${handle}"]`);
  let offset = 200;
  let offsetTop = target.offsetTop - offset;

  $("html, body").animate({ 
    scrollTop: offsetTop
  }, 500, () => {
    setActiveCollectionLink();
  });
}

const setActiveCollectionLink = () => {
  // In category tab mode the active pill is simply the selected category;
  // the scroll-spy behaviour is not used.
  if (window.__categoryTabsActive) return;
  let currentCollection = null;
  document.querySelectorAll('.build-box-collection').forEach((collection) => {
    if(!(collection.classList.contains('hidden') || collection.classList.contains('search-no-results'))) {
      if(currentCollection == null && _isScrolledIntoView(collection)) {
        currentCollection = collection;
      }
    }
  })
  if(currentCollection != null) {
    document.querySelector('.category-filter-link.active')?.classList.remove('active');
    document.querySelector(`.category-filter-link[data-handle="${currentCollection.dataset.collection}"]`)?.classList.add('active');
  }
}

const filterCollection = () => {
  document.querySelectorAll('.build-box-collection').forEach((collection) => {
    let category_filter_link = document.querySelector(`.category-filter-link[data-handle="${collection.dataset.collection}"]`);
    if(collection.querySelector('.build-box-product:not(.hidden)')) {
      collection.classList.remove('search-no-results');
      category_filter_link?.classList.remove('no-products');
    }
    else {
      collection.classList.add('search-no-results');
      category_filter_link?.classList.add('no-products');
    }
  })

  document.querySelectorAll('.build-box-collection').forEach((collection) => {
    let is_filtered = false;
    let age = parseInt(collection.dataset.age);
    let category_filter_link = document.querySelector(`.category-filter-link[data-handle="${collection.dataset.collection}"]`);

    if(document.querySelector('.build-box-filter-group input[name="age"]:checked')) {
      document.querySelectorAll('.build-box-filter-group input[name="age"]:checked').forEach((filter) => {
        let age_min = parseInt(filter.dataset.min);
        let age_max = parseInt(filter.dataset.max);  
        if(age >= age_min && age < age_max) {
          is_filtered = true;
        }
      })
    }
    else {
      is_filtered = true;
    }

    if(is_filtered) {
      collection.classList.remove('hidden');
      category_filter_link?.classList.remove('hidden');
    }
    else {
      collection.classList.add('hidden');
      category_filter_link?.classList.add('hidden');
    }
  })
  setActiveCollectionLink();
}

const filterProducts = () => {

  const query = (document.querySelector('.build-box-search-input')?.value || '').trim().toLowerCase();
  const isSearching = query.length > 0;

  // Individual product cards of BOTH markup styles:
  //  - `.build-box-product[data-product]` -> standard cards in collection blocks
  //  - `.guided-card--product`            -> cards used inside guided/most-loved/allergen sections
  const cards = document.querySelectorAll(
    '.build-box-contents .build-box-product[data-product], .build-box-contents .guided-card--product'
  );
  const checkedFilters = document.querySelectorAll('#dietaries-options .dietaries-filter__item[aria-checked="true"]');

  for (let i = 0; i < cards.length; i++) {
    const card = cards[i];
    let is_filtered = true;

    if (checkedFilters.length > 0) {
      for (let j = 0; j < checkedFilters.length; j++) {
        const filter = checkedFilters[j];
        if (
          card.querySelector(`span[data-tag="${filter.dataset.filter}"]`) ||
          card.querySelector(`span[data-front-tag="${filter.dataset.filter}"]`)
        ) {
          is_filtered = true;
        } else {
          is_filtered = false;
          break;
        }
      }
    }

    if (isSearching && is_filtered) {
      const titleEl = card.querySelector('.product--title, .guided-card__title');
      const tagEl   = card.querySelector('.product--tag');
      const p_title = titleEl ? titleEl.innerText.toLowerCase() : '';
      const p_tags  = tagEl   ? tagEl.innerText.toLowerCase()   : '';

      if (!(p_title.includes(query) || p_tags.includes(query))) {
        is_filtered = false;
      }
    }

    card.classList.toggle('hidden', !is_filtered);
  }

  // Hide the guided-bundles / most-loved / allergen-intro grids (and their section
  // headers) when none of their cards match. Also hide the Boob-to-Food bundle
  // carousel while the user is actively searching, since it has no searchable text.
  document.querySelectorAll('.build-box-contents .build-box-product.guided-bundles').forEach((grid) => {
    const anyVisible = grid.querySelector('.guided-card--product:not(.hidden)');
    grid.classList.toggle('hidden', !anyVisible);

    // The matching header sits immediately before the grid.
    const header = grid.previousElementSibling;
    if (header && header.classList.contains('guided-bundles__header')) {
      header.classList.toggle('hidden', !anyVisible);
    }
  });

  document.querySelectorAll('.build-box-contents .build-box-product.bundle-carousel').forEach((carousel) => {
    carousel.classList.toggle('hidden', isSearching);
  });

  filterCollection();

  if (typeof window.placeBuildBoxSearch === 'function') {
    window.placeBuildBoxSearch();
  }
}

const openQuickView = async () => {
  const quickView = document.querySelector('product-quickview');
  quickView?.classList.add('open');
}

const closeQuickView = () => {
  const quickView = document.querySelector('product-quickview');
  quickView?.classList.remove('open');
  setTimeout(() => {
    quickView.querySelector('.product-quickview').classList.add('empty');
  }, 300);
}

const updateStickyBar = async () => {
  const response = await fetch('/cart.js', {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json'
    }
  });
  const cart = await response.json();

  if(!document.querySelector('.build-box-stickybar')) return;
  document.querySelector('.build-box-stickybar').classList.add('visible');
  // document.querySelector('.build-box-sticky-count span').innerText = cart.item_count;
  document.querySelector('.build-box-sticky-price .original-price').innerText = formatMoney(cart.total_price);
  document.querySelector('.build-box-sticky-right .button .original-price').innerText = formatMoney(cart.total_price);
  
  if (cart.total_price > 5000) {
    document.querySelector('.stickybar-checkout-button').classList.remove('disabled');
  } else {
    document.querySelector('.stickybar-checkout-button').classList.add('disabled');
  }
  // document.querySelector('.build-box-sticky-price .discounted-price').innerText = formatMoney((cart.total_price) * 0.9);

}

const quickAddToCart = async (id, quantity) => {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    body: JSON.stringify({
        id: id,
        quantity: quantity,
    }),
    headers: {
        'Content-Type': 'application/json'
    }
  });
  const json = await response.json();

  document.querySelector('product-quickview').classList.remove('open');

  updateStickyBar();
  refreshCartItems();
  reloadCart();
  if (typeof renderPrecartItems === "function") {
    renderPrecartItems();
  }
  // return json;
}

const initQuickViewEvents = () => {
  // When user clicked variant dropdown
  document.querySelector('.product-current-variant')?.addEventListener('click', (e) => {
    e.target.closest('.product-variant-dropdown').classList.toggle('open');
  })
  document.querySelectorAll('.product-v-option').forEach((vOption) => {
    vOption.addEventListener('click', (e) => {
      document.querySelector('.product-current-variant label').innerText = vOption.innerText;
      e.target.closest('form').querySelector('[name="id"]').value = vOption.dataset.variantId;
      e.target.closest('.product-variant-dropdown').classList.remove('open');
    })
  })

  // When user clicked qty buttons
  document.querySelector('[data-qty-plus]')?.addEventListener('click', (e) => {
    e.preventDefault();
    let input = e.target.closest('.product-qty').querySelector('input');
    input.value = parseInt(input.value) + 1;
  })
  document.querySelector('[data-qty-minus]')?.addEventListener('click', (e) => {
    e.preventDefault();
    let input = e.target.closest('.product-qty').querySelector('input');
    if(parseInt(input.value) > 1) {
      input.value = parseInt(input.value) - 1;
    }
  })

  // When user cliecked quick view form submit
  document.querySelector('.product-quickview-content form .product-form-submit')?.addEventListener('click', async (e) => {
    
    e.preventDefault();
    let form = e.target.closest('form');
    let id = form.querySelector('select[name="id"]').value;
    let quantity = parseInt(form.querySelector('input[name="quantity"]').value, 10);
    await quickAddToCart(id, quantity);

    const products = document.querySelectorAll(
      `[data-product][data-product-id="${e.target.dataset.productId}"]`
    );


    products.forEach((product) => {
      if (product.classList.contains('cart-item')) {
        updateBuildProductQty(
          product,
          parseInt(product.querySelector('.build-box-product-qty .count').innerText, 10) + quantity
        );
      } else {
        product.classList.add('cart-item');
        updateBuildProductQty(product, quantity);
      }
    });
  })
}

const fetchProductQuickViewCnt = async (handle) => {
  const quickView = document.querySelector('product-quickview');
  quickView.querySelector('.product-quickview-content').innerHTML = '';
  if(!quickView) return;
  const response = await fetch(`/products/${handle}?view=quick-view`, {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  });
  const data = await response.text();

  quickView.querySelector('.product-quickview').classList.remove('empty');
  quickView.querySelector('.product-quickview-content').innerHTML = data;
  initQuickViewEvents();
  const isBundle = handle.includes('bundle');
  initQuickViewSwiper(isBundle);
}

const initQuickViewSwiper = (isBundle) => {
  const mainImageEl = document.querySelector('.product-quickview .product-main-image');
  const ingredientsEl = document.querySelector('.product-quickview .product-ingredients-swiper');
  const mainSlides = mainImageEl?.querySelectorAll('.swiper-slide')?.length || 0;

  // Only init the hero carousel when there is more than one image to swipe
  if (mainImageEl && mainSlides > 1) {
    const mainImageOptions = {
      slidesPerView: 1,
      spaceBetween: 16,
      autoHeight: true,
      navigation: {
        nextEl: mainImageEl.querySelector('.swiper-button-next'),
        prevEl: mainImageEl.querySelector('.swiper-button-prev'),
      },
    };

    if (!isBundle) {
      mainImageOptions.pagination = {
        el: mainImageEl.querySelector('.swiper-pagination'),
        clickable: true,
      };
    }

    new Swiper(mainImageEl, mainImageOptions);
  }

  if (ingredientsEl) {
    new Swiper(ingredientsEl, {
      slidesPerView: 1.7,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 4.6
        }
      }
    });
  }
}

const updateBuildProduct = async (id, prodId, qty, button) => {
  // Log the current cart contents to check product ids before updating
  //const currentCart = await fetch('/cart.js').then(res => res.json());
  //const currentItem = currentCart.items.find(item => item.variant_id == id);
  const currentItemVarId = id;
  const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: currentItemVarId,
        quantity: qty
      })
    });
  
  const data = await res.json();
  if(qty == 0) {
    button.closest('[data-product]').classList.remove('cart-item');
    document.querySelectorAll(`[data-product-id="${id}"]`).forEach(el => el.classList.remove('cart-item'));
  }
  else {
    button.closest('[data-product]').classList.add('cart-item');
    document.querySelectorAll(`[data-product-id="${id}"]`).forEach(el => el.classList.add('cart-item'));
  }
  if(res.status == 200){ 
    document
    .querySelectorAll(`[data-id="${id}"]`)
    .forEach(el => {
      const countEl = el.querySelector('.count');
      if (countEl) countEl.innerText = qty;
    });
    //updateBuildProductQty(button.closest('[data-product]'), qty);
    updateStickyBar();
    reloadCart();
    if (typeof renderPrecartItems === "function") {
      renderPrecartItems();
    }
  }
  else{
    Swal.fire({
      title: "Error adding item to cart",
      text: data.message || "Error adding item to cart",
      icon: 'error'
    });
  }
}

const updateBuildProductQty = (product, qty) => {
  product.querySelector('.build-box-product-qty .count').innerText = qty;
}

const initBuildboxEvents = () => {
  // When filter category clicked. In category tab mode, tab pills manage
  // their own clicks (they switch categories instead of scrolling).
  if (!window.__categoryTabsActive) {
    document.querySelectorAll('.category-filter-link').forEach((categoryLink) => {
      categoryLink.addEventListener('click', () => {
        scrollToCollection(categoryLink);
      })
    })
    document.querySelectorAll('.li_nav_header_link').forEach((categoryLink) => {
      categoryLink.addEventListener('click', () => {
        scrollToCollection(categoryLink);
      })
    })
  }

  // When filter input changed
  document.querySelectorAll('.build-box-filter-group input').forEach((input) => {
    input.addEventListener('change', () => {
      filterProducts();
    })
  })

  // When user inputs search query
  document.querySelector('.build-box-search-input')?.addEventListener('keyup', () => {
    filterProducts();
  })

  // When user clicked quick add button
  document.querySelectorAll('[data-product-quick-add]').forEach((quickAdd) => {
    quickAdd.addEventListener('click', async () => {
      await quickAddToCart(quickAdd.dataset.productId, 1);

      let product = quickAdd.closest('[data-product]');
      product.classList.add('cart-item');
      updateBuildProductQty(product, 1);
    })
  })
  
  // When user clicked quick view
  document.querySelectorAll('.build-box-product [data-product-quick-view]').forEach((quickView) => {
    if(quickView.dataset.productHandle != 'boob-to-food-x-le-puree-bundle'){
      quickView.addEventListener('click', () => {
        fetchProductQuickViewCnt(quickView.dataset.productHandle);
        openQuickView();
      })
    }
  })
  
  document.querySelectorAll('.product--title [data-product-quick-view]').forEach((quickView) => {
    quickView.addEventListener('click', () => {
      fetchProductQuickViewCnt(quickView.dataset.productHandle);
      openQuickView();
    })
  })

  // When user clicked quick view close
  document.querySelectorAll('[data-product-quickview-close]').forEach((close) => {
    close.addEventListener('click', () => {
      closeQuickView();
    })
  })
  // When user clicked product qty button
  document.querySelectorAll('.build-box-product-qty-plus').forEach((qty) => {
    qty.addEventListener('click', (e) => {
      e.preventDefault();
      let id = e.target.closest('[data-product]').dataset.id;
      let current_qty = parseInt(e.target.closest('.build-box-product-qty').querySelector('.count').innerText);
      let qty = current_qty + 1;
      let prodId = e.target.closest('[data-product]').dataset.productId;

      updateBuildProduct(id, prodId, qty, e.target);
    })
  })
  document.querySelectorAll('.build-box-product-qty-minus').forEach((qty) => {

    qty.addEventListener('click', (e) => {
      e.preventDefault();
      let id = e.target.closest('[data-product]').dataset.id;
      let current_qty = parseInt(e.target.closest('.build-box-product-qty').querySelector('.count').innerText);
      let qty = current_qty - 1;
      let prodId = e.target.closest('[data-product]').dataset.productId;
      
      if(qty < 0) {
        return;
      }
      updateBuildProduct(id, prodId, qty, e.target);
    })
  })

  // Mobile filter open/close
  if(_isMobile()) {
    let mobileFilter = document.querySelector('.build-box-filter');
    if(!mobileFilter) return;
    document.querySelectorAll('.mobile-filter-open').forEach((open) => {
      open.addEventListener('click', () => {
        mobileFilter.classList.add('open');
      })
    })
    document.querySelectorAll('.mobile-filter-close').forEach((open) => {
      open.addEventListener('click', () => {
        mobileFilter.classList.remove('open');
      })
    })
  }

  

}

window.addEventListener('DOMContentLoaded', async () => {
  initBuildboxEvents();
  setActiveCollectionLink();
  updateStickyBar();
  document.querySelector('.build-box-sticky-wrapper')?.addEventListener('cart:updated', () => {
    updateStickyBar();
  });
  const currentCart = await fetch('/cart.js').then(res => res.json());
  document.querySelectorAll('[data-product]').forEach(item => {
    const matchingItem = currentCart.items.find(dataItem => dataItem.product_id == item.dataset.productId);
    if (matchingItem) {
      item.querySelector('.build-box-product-qty .count').innerText = matchingItem.quantity;
      item.dataset.id = matchingItem.variant_id;
      if (matchingItem.quantity == 0) {
          item.classList.remove('cart-item');
      } else {
          item.classList.add('cart-item');
      }
    }
  })
})

document.addEventListener('scroll', (e) => {
  setActiveCollectionLink();
})

// Back to top button functionality
const backToTopButton = document.getElementById('backToTopBtn');

// Show button when user scrolls down 20px from the top of the document
window.onscroll = function() {
  if ((document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) && backToTopButton) {
    backToTopButton.style.display = "flex";
  } else {
    if (!backToTopButton) return;
      backToTopButton.style.display = "none";
  }
};

// Scroll to top when button is clicked
backToTopButton?.addEventListener('click', function() {
  // Smooth scroll to top
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });

});






